import { Skeleton, Table } from '@factorialco/deprecated-design-system'

const LoadingSkeleton = () => {
  return (
    <>
      <Table.Cell colSpan={5}>
        <Skeleton height="s16" width="s120" />
      </Table.Cell>
      <Table.Cell colSpan={3}>
        <Skeleton height="s16" width="s80" />
      </Table.Cell>
      <Table.Cell colSpan={3}>
        <Skeleton height="s16" width="s80" />
      </Table.Cell>
      <Table.Cell colSpan={3}>
        <Skeleton height="s16" width="s80" />
      </Table.Cell>
      <Table.Cell colSpan={3}>
        <Skeleton height="s16" width="s80" />
      </Table.Cell>
      <Table.Cell colSpan={3}>
        <Skeleton height="s16" width="s80" />
      </Table.Cell>
    </>
  )
}

export default LoadingSkeleton
